<template>
<div>
    <!-- <v-parallax src="../assets/main-oso.jpg" height="1100"> -->
    <v-parallax src="../assets/main-oso.jpg" height="100%" jumbotron>
    <!-- <v-parallax src="../assets/online-marketing-hIgeoQjS_iE-unsplash (1).jpg" height="1100"> -->
    <v-container  grid-list-xl>
    <!-- <v-container fluid fill-height class="home"> -->

        <v-layout row justify-center>
            <v-flex xs12 elevation-0>
                    <!-- <div class="sub-window">
                        <v-container grid-list-md>
                            <v-layout row align-center>
                                <v-flex xs12> -->
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="text-center">
                                        <img
                                            height="200"
                                            :src="mainLogo"
                                        />
                                        <br />
                                    </v-card-text>
                                    <!-- <v-card-text class="indigo--text text--darken-4 body-1 text-left"> -->
                                    <v-card-text class="white--text title text-left my-shadow">
                                        Grupo Médico Pediátrico somos un grupo de médicos especialistas que desde hace ya más de 42 años buscamos la excelencia para todos nuestros pequeños pacientes.
                                        <p></p>
                                        Hemos formado uno de los grupos pediátricos más prestigiados y profesionales de la Ciudad de México.
                                        Todos los doctores que integramos este grupo nos dedicamos con entrega a la salud de los niños desde
                                        el nacimiento hasta la mayoría de edad. Tenemos muy claro que la salud física y mental de los niños
                                        es vital para un desarrollo sano y en armonía para ellos y toda su familia.
                                    </v-card-text>
                                </v-card>
                            <!-- </v-flex>
                        </v-layout>
                    </v-container>
                </div> -->
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-around>
            <v-flex
                v-for="noticia in noticias"
                xs6 sm4>
                <v-card>
                    <v-img
                        :src = "noticia.foto"
                        class="white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.8)"
                        height="200px"
                    >
                        <v-card-title v-text="noticia.titulo"></v-card-title>
                    </v-img>
                    
                    <v-card-text
                        class="font-weight-medium blue--text text--darken-4"
                        v-text="noticia.texto">
                    </v-card-text>
                    
                </v-card>
            </v-flex>
        </v-layout> 
    </v-container>
        
    </v-parallax>
        <v-footer
            dark
            padless
        >
            <v-container fluid pa-0>
                <v-card
                    flat
                    tile
                    class="white--text text-center title"
                    color="rgb(0, 44, 66)"
                >
                    <v-layout row>
                        <v-flex xs12>
                            <v-card-text>
                                <v-btn
                                    v-for="icon in icons"
                                    :key="icon"
                                    class="mx-4 white--text"
                                    icon
                                >
                                    <v-icon size="24px">
                                        {{ icon }}
                                    </v-icon>
                                </v-btn>
                            </v-card-text>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 md2>
                            <v-card-text class="text-center">
                                <img
                                    height="100"
                                    :src="mainLogo"
                                />
                            </v-card-text>
                        </v-flex>
                        <v-flex xs6 md2>
                            <v-container fluid>
                                
                                <v-layout row> 
                                    <v-flex xs12 class="d-flex justify-left">
                                        Navegación
                                    </v-flex>
                                </v-layout>
                                <v-layout row>

                                    <v-flex xs12>
                                            <v-list dense color="rgb(0, 44, 66)" class = "text-left">
                                                <v-list-item @click="onServicios">
                                                    <v-list-item-title>
                                                        <v-icon small @click>mdi-chevron-right</v-icon
                                                        >&nbsp; Servicios
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="onEspecialidades">
                                                    <v-list-item-title>
                                                        <v-icon small @click="onEspecialidades">mdi-chevron-right</v-icon
                                                        >&nbsp; Especialidades
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="onLaboratorio">
                                                    <v-list-item-title>
                                                        <v-icon small @click="onLaboratorio">mdi-chevron-right</v-icon
                                                        >&nbsp; Laboratorio
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="onSitiosDeInteres">
                                                    <v-list-item-title>
                                                        <v-icon small @click="onSitiosDeInteres">mdi-chevron-right</v-icon
                                                        >&nbsp; Sitios de Interés
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="onContacto">
                                                    <v-list-item-title>
                                                        <v-icon small @click="onContacto">mdi-chevron-right</v-icon
                                                        >&nbsp; Contacto
                                                    </v-list-item-title>
                                                </v-list-item>
                                                
                                            </v-list>
                                    </v-flex>
                                </v-layout>

                                <!-- </v-span> -->
                                    
                            </v-container>
                                
                        </v-flex>
                        <v-flex xs6 sm8 class="d-flex justify-left">
                            <v-container fluid>
                                <v-layout row> 
                                    <v-flex xs12 class="d-flex justify-left">
                                        Nuestras Clínicas
                                    </v-flex>
                                </v-layout>
                                
                                <v-layout row justify-space-between>
                                    <v-flex xs12 md3 class="d-flex justify-left">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12  class="d-flex justify-left">
                                                    <v-span class="gmpgreen">
                                                        Prado Sur
                                                    </v-span>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-map-marker</v-icon> &nbsp;Prado Sur 290
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Col. Lomas de Chapultepec, 1100
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Miguel Hidalgo, Cd. México
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-phone</v-icon> &nbsp;55-1100-1200
                                                </v-flex>
                                            </v-layout>
                                        
                                        </v-container>
                                    </v-flex>
                                    <v-flex xs12 md4 class="d-flex justify-left">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12  class="d-flex justify-left">
                                                    <v-span class="gmpgreen">
                                                        Centro Médico ABC-Santa Fe
                                                    </v-span>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-map-marker</v-icon> &nbsp;Torre de Ginecología-Obstetricia y Pediatría
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Consultorio 2 - Planta Baja
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Av. Carlos Gral. Fernández 154
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Col. Tlaxcala, 05300
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Cuajimalpa, Cd. México
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-phone</v-icon> &nbsp;55-1664-7197, 55-1664-7198
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    <v-flex xs12 md4 class="d-flex justify-left title">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12  class="d-flex justify-left">
                                                    <v-span class="gmpgreen">
                                                        Hospital Ángeles Lomas
                                                    </v-span>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-map-marker</v-icon> &nbsp;Torre de Consultorios
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Consultorio 330
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Av. Vialidad de la Barranca S/N
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Col. Valle de las Palmas, 52763
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    Huixquilucan, Estado de México
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-left body-2">
                                                    <v-icon small>mdi-phone</v-icon> &nbsp;55-5246-9700, 55-5246-9701
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                    </v-layout>

                <v-divider></v-divider>

                <v-card-text class="white--text">
                    © Derechos Reservados {{ new Date().getFullYear() }} Grupo Médico Pediátrico, S.C.
                    <v-span class="gmpgreen">
                        &nbsp; Aviso de Privacidad
                    </v-span>
                </v-card-text>
                </v-card>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            icons: [
                'mdi-facebook',
                'mdi-twitter',
                'mdi-linkedin',
                'mdi-instagram',
            ],
        };
    },
    created() {
        // var bp = '';
        // if (this.$vuetify.breakpoint.xs) {
        //     bp = 'xs';
        // } else if (this.$vuetify.breakpoint.sm) {
        //     bp = 'sm';
        // } else if (this.$vuetify.breakpoint.md) {
        //     bp = 'md';
        // } else if (this.$vuetify.breakpoint.lg) {
        //     bp = 'lg';
        // } else if (this.$vuetify.breakpoint.xl) {
        //     bp = 'xl';
        // }
        // console.log('Breakpoint = ', bp);
         if (this.noticias.length === 0) {
            this.$store.dispatch('fetchNoticias');
        }

    },
    computed: {
        ...mapGetters(['version', 'mainLogo', 'noticias']),
        
    },
    methods: {
        onServicios(){

        },
        onEspecialidades(){

        },
        onLaboratorio(){},
        onSitiosDeInteres(){},
        onContacto(){},
    }
};
</script>

<style scoped>
.home {
    /* background: url('../assets/online-marketing-hIgeoQjS_iE-unsplash (1).jpg'); */
    background: url('../assets/main-oso.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background: rgba(0, 0, 0, 0.7); */
    background: rgba(211, 214, 212, 0.6);
}

.my-shadow {
    text-shadow: 2px 2px 4px black, 0 0 5px grey, 0 0 5px black;
}

.gmpgreen {
    color: rgb(92, 155, 152);
}

.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
